import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof2: FaireReviewEntity = {
  token: "review_sof2",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_bekx8fcudn",
  reviewerName: "Lynn",
  reviewerLocation: "Del Mar, CA",
  stars: 5,
  reviewText: "Cannot keep the pink ruffle robe in stock, definitely a winner!",
  reviewDate: "Apr 23, 2024",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
